import {
  SET_SURGERY_TYPE,
  ADD_SURGERY_HISTORY_DATA,
  DELETE_SURGERY_HISTORY_DATA,
  GET_SURGERY_PARTS,
  GET_SURGERY_HISTORY_DATA,
  SET_SURGERY_HISTORY_DATA,
} from "./actionType";

const defaultState = {
  surgeryType: [{ name: "没有", id: 1 }],//选择有还是无手术
  surgeryList: [],//手术列表
  surgeryListIndex: [],//缓存的手术列表
  surgeryParts: [],//手术部位
};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_SURGERY_TYPE://设置
      return { ...state, ...action };
    case SET_SURGERY_HISTORY_DATA://设置
      return { ...state, ...action };
    case ADD_SURGERY_HISTORY_DATA://添加手术
      return { ...state, ...action.params };
    case DELETE_SURGERY_HISTORY_DATA://删除手术
      return { ...state, ...action.params };
    case GET_SURGERY_PARTS: //获取手术部位的列表
      return { ...state, ...action };
    case GET_SURGERY_HISTORY_DATA: //获取手术的列表
      return { ...state, ...action.values };
    default:
      return state;
  }
};

export default Reducer;
